/**
 * settings-payment.js
 *
 * @author:          Fabian Tollenaar <fabian> <fabian@decipher.industries>
 * @date:            2018-02-12 22:56
 * @copyright:       Fabian Tollenaar/Decipher Industries (c) 2018. All rights reserved.
 * @license:         UNLICENSED
 * @modified:        2018-10-16 22:27
 */

import './styles.styl'
import 'react-toggle/style.css'

import React from 'react'
// import Autocomplete from 'react-autocomplete'
import Toggle from 'react-toggle'

export default class SettingsPayment extends React.Component {
  constructor (props) {
    super(props)

    let state = {
      budget: false,
      budgetSpendIncludingVAT: false,
      budgetPerUser: false,
      additionalPayments: false,
      additionalPaymentsMode: 'finish_credits', // enum: finish_credits, always, margin
      additionalPaymentsMargin: 0,
      credits: false,
      creditsValue: 0.15,
      paymentServiceDevelopmentKey: '',
      paymentServiceProductionKey: '',
      paymentServiceMode: 'production',
      idealPayment: (props.storeType === 'S-STORE'),
      priceStaffelMode: 'ALL',
      leaveHours: (props.storeType === 'S-STORE'),
      leaveHoursValue: 15,
      initialCreditsValue: 0,
    }

    if (props.data !== null) {
      state = {
        ...state,
        ...props.data
      }
    }

    this.state = state
  }

  slugify (text) {
    return String(text)
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }

  saveAndToggle (index) {
    this.props.save({ ...this.state })
    this.props.toggleSection(index)
  }

  saveAndNext (index) {
    this.props.save({ ...this.state })
    this.props.nextSection(index)
  }

  saveAndClose (index) {
    this.props.save({ ...this.state })
    this.props.close()
  }

  render () {
    const index = this.props.index
    const content = []

    content.push(
      <div className={this.state.leaveHours === false ? 'row subsection' : 'row subsection no-margin'} key={content.length}>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Betalen met verlofuren</label>
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.leaveHours}
              onChange={e => this.setState({ leaveHours: e.target.checked })}
            />
            <span>Verlofuren gebruiken</span>
          </div>
        </div>
      </div>
    )

    if (this.state.leaveHours === true) {
      content.push(
        <div className='row subsection' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <label>Waarde van één verlofuur:</label>
            <br />
            <input
              type='text'
              value={this.state.leaveHoursValue}
              onChange={e => this.setState({ leaveHoursValue: e.target.value })}
              className='form-control form-control-sm'
              placeholder='E.g.: €15'
            />
          </div>
        </div>
      )
    }

    content.push(
      <div className={this.state.budget === false ? 'row subsection' : 'row subsection no-margin'} key={content.length}>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Budget</label>
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.budget}
              onChange={e => this.setState({ budget: e.target.checked })}
            />
            <span>Budget gebruiken</span>
          </div>
        </div>
      </div>
    )

    if (this.state.budget === true) {
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.budgetSpendIncludingVAT}
                onChange={e => this.setState({ budgetSpendIncludingVAT: e.target.checked })}
              />
              <span>Orders worden inclusief BTW van budget afgschreven</span>
            </div>
          </div>
        </div>
      )

      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={!this.state.budgetSpendIncludingVAT}
                onChange={e => this.setState({ budgetSpendIncludingVAT: !e.target.checked })}
              />
              <span>Orders worden exclusief BTW van budget afgschreven</span>
            </div>
          </div>
        </div>
      )

      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={!this.state.budgetPerUser}
                onChange={e => this.setState({ budgetPerUser: !e.target.checked })}
              />
              <span>Algemeen budget</span>
            </div>
          </div>
        </div>
      )

      content.push(
        <div className='row subsection' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.budgetPerUser}
                onChange={e => this.setState({ budgetPerUser: e.target.checked })}
              />
              <span>Budget per (groep) gebruiker(s)</span>
            </div>
          </div>
        </div>
      )
    }

    /* MARK */
    content.push(
      <div className={this.state.idealPayment === false ? 'row subsection' : 'row subsection no-margin'} key={content.length}>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>iDeal/CC</label>
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.idealPayment}
              onChange={e => this.setState({ idealPayment: e.target.checked })}
            />
            <span>Hele order betalen met ideal/CC mogelijk</span>
          </div>
        </div>
      </div>
    )

    if (this.state.idealPayment === true) {
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            <label className='form-label'>Betaalprovider</label>
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.paymentServiceMode === 'production'}
                onChange={e => this.setState({ paymentServiceMode: e.target.checked === true ? 'production' : 'development' })}
              />
              <span>Productiemodus: {this.state.paymentServiceMode === 'production' ? 'aan' : 'uit'}</span>
            </div>
          </div>
        </div>
      )
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='form-group'>
              <label className='form-label'>API sleutel (productie)</label>
              <input type='text' className='form-control' value={this.state.paymentServiceProductionKey} onChange={e => this.setState({ paymentServiceProductionKey: e.target.value })} />
            </div>
          </div>
        </div>
      )
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='form-group'>
              <label className='form-label'>API sleutel (development)</label>
              <input type='text' className='form-control' value={this.state.paymentServiceDevelopmentKey} onChange={e => this.setState({ paymentServiceDevelopmentKey: e.target.value })} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )
    }
    /* END MARK */

    content.push(
      <div className={this.state.additionalPayments === false ? 'row subsection' : 'row subsection no-margin'} key={content.length}>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Bijbetaling</label>
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.additionalPayments}
              onChange={e => this.setState({ additionalPayments: e.target.checked })}
            />
            <span>Bijbetalen mogelijk</span>
          </div>
        </div>
      </div>
    )

    if (this.state.additionalPayments === true) {
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            <label className='form-label'>Betaalprovider</label>
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.paymentServiceMode === 'production'}
                onChange={e => this.setState({ paymentServiceMode: e.target.checked === true ? 'production' : 'development' })}
              />
              <span>Productiemodus: {this.state.paymentServiceMode === 'production' ? 'aan' : 'uit'}</span>
            </div>
          </div>
        </div>
      )
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='form-group'>
              <label className='form-label'>API sleutel (productie)</label>
              <input type='text' className='form-control' value={this.state.paymentServiceProductionKey} onChange={e => this.setState({ paymentServiceProductionKey: e.target.value })} />
            </div>
          </div>
        </div>
      )
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='form-group'>
              <label className='form-label'>API sleutel (development)</label>
              <input type='text' className='form-control' value={this.state.paymentServiceDevelopmentKey} onChange={e => this.setState({ paymentServiceDevelopmentKey: e.target.value })} />
              <br />
              <br />
            </div>
          </div>
        </div>
      )

      // enum: finish_credits, always, margin
      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.additionalPaymentsMode === 'finish_credits'}
                onChange={e => this.setState({ additionalPaymentsMode: e.target.checked ? 'finish_credits' : 'default' })}
              />
              <span>Scenario: bijbetalen om punten op te maken</span>
            </div>
          </div>
        </div>
      )

      content.push(
        <div className='row subsection no-margin' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.additionalPaymentsMode === 'always'}
                onChange={e => this.setState({ additionalPaymentsMode: e.target.checked ? 'always' : 'default' })}
              />
              <span>Scenario: altijd mogelijk om bij te betalen (slider)</span>
            </div>
          </div>
        </div>
      )

      content.push(
        <div className={this.state.additionalPaymentsMode === 'margin' ? 'row subsection' : 'row subsection no-margin'} key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <div className='toggle-switch'>
              <Toggle
                checked={this.state.additionalPaymentsMode === 'margin'}
                onChange={e => this.setState({ additionalPaymentsMode: e.target.checked ? 'margin' : 'default' })}
              />
              <span>Scenario: bijbetalen van vaste marge</span>
            </div>
          </div>
        </div>
      )

      if (this.state.additionalPaymentsMode === 'margin') {
        content.push(
          <div className='row subsection' key={content.length}>
            <div className='col-12 col-sm-4'>
              &nbsp;
            </div>

            <div className='col-12 col-sm-8'>
              <label>Vaste marge (%):</label>
              <br />
              <input
                type='text'
                value={this.state.additionalPaymentsMargin}
                onChange={e => this.setState({ additionalPaymentsMargin: e.target.value })}
                className='form-control form-control-sm'
                placeholder='0%'
              />
            </div>
          </div>
        )
      }
    }

    content.push(
      <div className={this.state.credits === false ? 'row subsection' : 'row subsection no-margin'} key={content.length}>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Punten</label>
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch'>
            <Toggle
              checked={this.state.credits}
              onChange={e => this.setState({ credits: e.target.checked })}
            />
            <span>Betalen met punten</span>
          </div>
        </div>
      </div>
    )

    if (this.state.credits === true) {
      content.push(
        <div className='row subsection' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <label>Waarde van één punt (€):</label>
            <br />
            <input
              type='text'
              value={this.state.creditsValue}
              onChange={e => this.setState({ creditsValue: e.target.value })}
              className='form-control form-control-sm'
              placeholder='€0.15'
            />
          </div>
        </div>
      )



      content.push(
        <div className='row subsection' key={content.length}>
          <div className='col-12 col-sm-4'>
            &nbsp;
          </div>

          <div className='col-12 col-sm-8'>
            <label>Initiële punten toekennen aan nieuwe gebruikers:</label>
            <br />
            <input
              type='text'
              value={this.state.initialCreditsValue}
              onChange={e => this.setState({ initialCreditsValue: e.target.value })}
              className='form-control form-control-sm'
              placeholder='E.g.: €15'
            />
          </div>
        </div>
      )
    }

    /* priceStaffelMode */
    content.push(
      <div className='row subsection' key={content.length}>
        <div className='col-12 col-sm-4'>
          <label className='form-label'>Staffels</label>
        </div>

        <div className='col-12 col-sm-8'>
          <div className='toggle-switch' style={{ marginTop: '1em' }}>
            <Toggle
              checked={this.state.priceStaffelMode === 'ALL'}
              onChange={e => this.setState({ priceStaffelMode: e.target.checked === true ? 'ALL' : 'FROM_FIRST' })}
            />
            <span>Korting van toepassing vanaf het eerste product</span>
          </div>

          <div className='toggle-switch'>
            <Toggle
              checked={this.state.priceStaffelMode === 'FROM_FIRST'}
              onChange={e => this.setState({ priceStaffelMode: e.target.checked === true ? 'FROM_FIRST' : 'ALL' })}
            />
            <span>Korting van toepassing vanaf de eerste staffel</span>
          </div>
        </div>
      </div>
    )

    return (
      <section key={index} className={['section', (this.props.open ? 'section-open' : 'section-closed')].join(' ')}>
        <div className='row section-title'>
          <div className='col-10'>
            <h3>Betaling</h3>
          </div>

          <div className='col-2 text-align-right'>
            <a href='#' onClick={() => this.saveAndToggle(index)} className='edit-link'>{this.props.open ? 'Sluiten' : 'Bewerken'}</a>
          </div>
        </div>

        <div className='row section-content'>
          <div className='col-12 col-lg-10'>
            {content}
          </div>
        </div>

        <div className='row section-buttons'>
          <div className='col-12 text-align-right'>
            {this.props.saving === false && <button className='btn btn-sm btn-success btn-rounded' onClick={() => this.saveAndClose(index)}>Opslaan &amp; sluiten &raquo;</button>}
            {this.props.saving === true && <button className='btn btn-sm btn-secondary btn-rounded' disabled>Momentje...</button>}
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/settings-payment.js